<template>
<!--  XXX: this is leaved in case we need to go back to dropdowns -->
<!--  <li>-->
<!--    <a v-if="!to" v-on="$listeners">-->
<!--      <i-->
<!--        class="fa"-->
<!--        :class="icon"-->
<!--      /> {{ title }}-->
<!--    </a>-->
<!--    <router-link v-if="to" :to="to" tag="a">-->
<!--      <i-->
<!--        class="fa"-->
<!--        :class="icon"-->
<!--      /> {{ title }}-->
<!--    </router-link>-->
<!--  </li>-->
  <span>
    <a
      v-if="href"
      :title="title"
      :href="href"
    >
      <i
        v-if="icon"
        class="fa"
        :class="icon"
      />
      <img
        v-if="iconSrc"
        :src="iconSrc"
        style="width:17px; padding-right:2px; margin-top: -2px;"
      />
    </a>
    <router-link
      v-if="to"
      :to="to"
      tag="a"
      :title="title"
    >
      <i
        class="fa"
        :class="icon"
      />
    </router-link>
    <a
      v-if="!to && !href"
      v-on="$listeners"
      :title="title"
    >
      <i
        class="fa"
        :class="icon"
      />
    </a>
  </span>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    iconSrc: {
      type: String,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    to: {
      type: Object,
      required: false
    },
  },

  setup(props) {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.fa {
  color: #333;
  font-size: 14px;
  padding: 2px;
  transition: .3s color, .3s background-color;

  &:hover {
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// ActionsMenuItem.vue?677e7b7a